import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  loading: false,
  error: null,
  exportExpireReceipt: { loading: false, error: null },
  count: 0,
};

//  Define slice and it's reducer functions.
const monitorExpireReceiptsSlice = createSlice({
  name: "monitorExpireReceipts",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProject(state, action) {
      state.project = action.payload;
    },
    setMonitorExpireExport(state, action) {
      state.exportExpireReceipt = {
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    setCount(state, action) {
      state.count = action.payload;
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.project = null;
    },
  },
});

export const monitorExpireReceiptsAction = monitorExpireReceiptsSlice.actions;

export default monitorExpireReceiptsSlice;
